export const getBusinessDaysApi = (params) => {
    return `/lease/${params?.leaseSlug}/lease_settings/business_days`;
}
export const updateBusinessDaysApi = (params) => {
    return `/lease/${params?.leaseSlug}/lease_settings/business_days`;
}

export const getManagementFeeConfig = (params) => {
    return `/lease/${params?.leaseSlug}/management-fee-config/`;
}
export const updateManagementFeeConfig = (params) => {
    return `/lease/${params?.leaseSlug}/management-fee-config/`;
}

export const getInvoiceHeaderConfigApi = (params) => {
    return `/lease/${params.leaseSlug}/lease_settings/invoice_header_config`;
}
export const updateInvoiceHeaderLogoApi = (params) => {
    return `/lease/${params.leaseSlug}/lease_settings/invoice_header_config/logo`;
}
export const updateInvoiceHeaderSectionApi = (params,sectionTitle) => {
    return `/lease/${params.leaseSlug}/lease_settings/invoice_header_config/section/${sectionTitle}`;
}
export const updateInvoiceHeaderAllSectionsApi = (params) => {
    return `/lease/${params.leaseSlug}/lease_settings/invoice_header_config/section`;
}
export const partiesApi = (params) => {
    return `/lease/${params?.leaseSlug}/parties?lite=true`;
};
